import './MobileBenefitsDropdown.scss';

import React, { Fragment, useState } from 'react';
import { ReactComponent as ChevronDown } from 'assets/icons/chevron-down.svg';
import { ReactComponent as ChevronUp } from 'assets/icons/chevron-up.svg';
import { contentConverter } from 'services/Content';

const MobileBenefitsDropdown = ({
  title,
  description,
  footer,
  isPremiumInvestorTile
}) => {
  const [open, togglePanel] = useState(false);
  const contentHtml = contentConverter.makeHtml(description);

  return (
    <Fragment>
      <div className="mobile-benefits-card-container">
        <div
          onClick={() => togglePanel(!open)}
          className="mobile-benefits-card-title">
          {title}
          {open ? (
            <ChevronUp className="chevron" />
          ) : (
            <ChevronDown className="chevron" />
          )}
        </div>
        {open ? (
          <div
            className={`mobile-benefits-card-body ${
              isPremiumInvestorTile ? 'premium-investor' : ''
            }`}>
            {description && (
              <div className="mobile-benefits-card-description">
                <span dangerouslySetInnerHTML={{ __html: contentHtml }} />
              </div>
            )}
            {footer && (
              <div className="mobile-benefits-card-footer">{footer}</div>
            )}
          </div>
        ) : null}
      </div>
    </Fragment>
  );
};

MobileBenefitsDropdown.defaultProps = {
  description: '',
  isPremiumInvestorTile: false
};

export default MobileBenefitsDropdown;
